module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAQAAACMJlQBAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4ggCDhAyhar9uAAAAQxJREFUGNNlkLFLAnEYhp/feTqIWkQQRZFFBFFDcVtrVHO0S1tzf0UN/QOtQTQVtUo0BQ5KghQoQTdKGVJJdp3Z25DeHfas7/O+8H0GlDA+ATIs4xCnQolR2iirnIYjwraK+tSXqjrWkdbQplwdaK4XT+pafTq61bpNiwR7rOiUG+pMsRCMGUqUbVwKbLHBKjWqxEgFgkfBvNjMMoJHkhQODsIEgk8DLF5Jk4zMhjRwAVnKqaKu/nOiDFjmhzx3tBnkmXPzDhbwxgPeQNzljKvwORntqKjvYLyrCy3+ZbbSZJnBYZxYz29xyaG577eXtK+ymvLV0YfqymtXY0TP0hDzTDNBnCaP1HgyCoVfWQaX2X0pR0AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/assets/img/twitter_logo.png
// module id = 567
// module chunks = 79611799117203